import { useNavigate } from 'react-router-dom'

export const getBrowserName = (uas) => {
  if (typeof uas !== 'undefined') {
    const ca = uas.indexOf('Chrome') > -1

    const iea = uas.indexOf('MSIE') > -1 || uas.indexOf('rv:') > -1

    const edge = uas.indexOf('Edge') > -1

    const edgchromium = uas.indexOf('Edg') > -1 // New version of Edge from Version 79 onwards

    const fa = uas.indexOf('Firefox') > -1

    const sa = uas.indexOf('Safari') > -1

    const ioswv = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test(uas) // IOS webview

    const oa = uas.indexOf('OP') > -1

    if (edge) return 'edge'
    if (edgchromium) return 'edgchromium'
    if (oa) return 'opera'
    if (ca) return 'chrome'
    if (fa) return 'firefox'
    if (sa) return 'safari'
    if (ioswv) return 'ioswebview' // IOS UIWebview
    if (iea) return 'ie'
  }
  return null
}

export const mobileChannels = ['iOSRebraded', 'android rebranded']
export const ipadChannels = ['ipad rebranded']
export const desktopChannels = ['OLB']
export const tuxChannels = ['TUX']
export const mobileIpadChannels = [...mobileChannels, ...ipadChannels]
export const desktopIpadChannels = [...desktopChannels, ...ipadChannels]
export const mobileTuxChannels = [...mobileChannels, ...tuxChannels]

export const getChannelId = () => {
  let channel = null

  if (typeof sessionStorage !== 'undefined' && sessionStorage) {
    if ('channelId' in sessionStorage) {
      channel = sessionStorage.channelId
    } else if ('Channel' in sessionStorage) {
      channel = sessionStorage.Channel
    }

    return channel
  }

  return channel
}

export const isMobileApp = () => mobileChannels.includes(getChannelId())
export const isMobileOrIpadApp = () =>
  mobileIpadChannels.includes(getChannelId())
export const isIpadApp = () => ipadChannels.includes(getChannelId())
export const isOLBApp = () => desktopChannels.includes(getChannelId())
export const isTuxApp = () => tuxChannels.includes(getChannelId())
export const isOLBOrIpadApp = () => desktopIpadChannels.includes(getChannelId())
export const isMobileOrTuxApp = () => mobileTuxChannels.includes(getChannelId())
export const getOrigin = () =>
  typeof window !== 'undefined' && window.location.origin

export const navigateRoute = () => {
  const navigate = useNavigate()
  const navigateRoutePath = (routerPath) => {
    navigate(routerPath)
  }
  return { navigateRoutePath }
}

export const assignWindowLocation = (url) =>
  typeof window !== 'undefined' && window.location.assign(url)
